"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  Audio: () => Audio
});
module.exports = __toCommonJS(unavailable_exports);
var import_validateCallback = require("../validateCallback");
var import_nativeError = require("../nativeError");
var Audio = Object.freeze({
  getRecordingPermissionStatus: function getRecordingPermissionStatus() {
    return Promise.resolve("denied");
  },
  requestRecordingPermission: function requestRecordingPermission() {
    return Promise.resolve("denied");
  },
  play: function play(_uri) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Audio.play"));
  },
  getPlaybackStatus: function getPlaybackStatus() {
    return Promise.resolve({
      state: "idle",
      positionMs: 0
    });
  },
  pause: function pause() {
    return Promise.resolve({
      state: "idle",
      positionMs: 0
    });
  },
  resume: function resume() {
    return Promise.resolve({
      state: "idle",
      positionMs: 0
    });
  },
  seek: function seek(_positionMs) {
    return Promise.resolve({
      state: "idle",
      positionMs: 0
    });
  },
  stop: function stop() {
    return Promise.resolve();
  },
  startRecording: function startRecording() {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Audio.startRecording"));
  },
  getRecordingStatus: function getRecordingStatus() {
    return Promise.resolve({
      state: "idle",
      durationMs: 0
    });
  },
  pauseRecording: function pauseRecording() {
    return Promise.resolve({
      state: "idle",
      durationMs: 0
    });
  },
  resumeRecording: function resumeRecording() {
    return Promise.resolve({
      state: "idle",
      durationMs: 0
    });
  },
  stopRecording: function stopRecording() {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Audio.stopRecording"));
  },
  watchInterruptions: function watchInterruptions(onEvent) {
    (0, import_validateCallback.validateCallback)(onEvent, "Audio.watchInterruptions: onEvent must be a function");
    return function() {
    };
  },
  setNowPlayingInfo: function setNowPlayingInfo(_info) {
    return Promise.resolve();
  },
  clearNowPlayingInfo: function clearNowPlayingInfo() {
    return Promise.resolve();
  },
  watchRemoteCommands: function watchRemoteCommands(onEvent) {
    (0, import_validateCallback.validateCallback)(onEvent, "Audio.watchRemoteCommands: onEvent must be a function");
    return function() {
    };
  }
});
//# sourceMappingURL=unavailable.js.map
